import API from "../../../utils/api";

export const getReturnCostPayersApi = async (filters) => {
  const response = await API.get("settings/return-cost-payer", { params: filters });
  return { response };
};

export const addReturnCostPayersApi = async (data) => {
  const response = await API.post("settings/return-cost-payer", data);
  return { response };
};

export const updateReturnCostPayersApi = async (data, id) => {
  const response = await API.put(`settings/return-cost-payer/${id}`, data);
  return { response };
};

export const deleteReturnCostPayersApi = async (id) => {
  const response = await API.delete(`settings/return-cost-payer/${id}`);
  return { response };
};
